package ir.site.zero1plus.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.stevdza.san.kotlinbs.components.showToast
import com.stevdza.san.kotlinbs.forms.BSTextArea
import com.varabyte.kobweb.browser.http.HttpMethod
import com.varabyte.kobweb.browser.http.fetch
import com.varabyte.kobweb.compose.css.BoxShadow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.extendedBy
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import ir.site.zero1plus.components.widgets.PrimaryButton
import ir.site.zero1plus.components.widgets.SectionHeading
import ir.site.zero1plus.model.NavBarMenu
import ir.site.zero1plus.theme.*
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Form
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Text

val MyInputStyle = SmoothColorStyle.extendedBy {
    val isDark = colorMode.isDark
    base {
        Modifier
            .border {
                color(if (isDark) Colors.White.copyf(alpha = 0.10f) else Colors.Black.copyf(alpha = 0.10f))
                width(1.px)
            }
            .caretColor(if (isDark) TextPrimaryDark else TextPrimaryLight)
            .backgroundColor(if (isDark) SurfaceDark else SurfaceLight)
            .width(250.px)
            .display(DisplayStyle.Block)
            .transition(Transition.of("border", 300.ms))
    }

    /*    cssRule(" ::placeholder"){
            Modifier.color(if (isDark) TextSecondaryDark else TextSecondaryLight)
        }*/

    Breakpoint.MD {
        Modifier.width(500.px)
    }

    hover {
        Modifier.border {
            color(if (isDark) PrimaryDark else PrimaryLight)
            width(1.px)
        }
    }
    focus {
        Modifier
            .border {
                color(if (isDark) PrimaryDark else PrimaryLight)
                width(1.px)
            }
            .boxShadow(BoxShadow.None)
    }

}

@Composable
fun ContactMeSection() {
    Box(
        modifier = Modifier
            .id(NavBarMenu.ContactDetails.id)
            .fillMaxWidth(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.padding(topBottom = 150.px),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            SectionHeading(
                title = "ارتباط با من"
            )
            ContactForm()
        }

    }

}

@Composable
fun ContactForm() {
    val coroutine = rememberCoroutineScope()
    Form(
        action = "your-backend",
        attrs = Modifier.id("myContactForm").attrsModifier {
            attr("method", "POST")
        }.toAttrs {
            onSubmit {
                it.preventDefault()

                coroutine.launch {
                    window.fetch(
                        method = HttpMethod.GET,
                        resource = "https://zero1plus.ir/backend"
                    )
                }

            }
        },
    ) {
        Label(
            attrs = Modifier
                .classNames("form-label")
                .toAttrs(),
            forId = "inputName"
        ) {
            Text("نام و خانوادگی")
        }

        Input(
            modifier = MyInputStyle.toModifier().id("inputName")
                .margin(bottom = 10.px),
            type = InputType.Text,
            value = "",
            onValueChange = {

            },
            required = true
        )

        Label(
            attrs = Modifier
                .classNames("form-label")
                .toAttrs(),
            forId = "inputEmail"
        ) {
            Text("ایمیل")
        }


        Input(
            modifier = MyInputStyle.toModifier().id("inputEmail")
                .margin(bottom = 10.px),
            type = InputType.Text,
            value = "",
            onValueChange = {

            },
            required = true,
        )

        Label(
            attrs = Modifier
                .classNames("form-label")
                .toAttrs(),
            forId = "inputMessage"
        ) {
            Text("پیام")
        }
        BSTextArea(
            modifier = MyInputStyle.toModifier()
                .height(150.px)
                .margin(bottom = 20.px),
            value = "",
            onValueChange = {

            },
            id = "inputMessage"
        )

        Box(
            modifier = Modifier.fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            PrimaryButton(
                buttonType = ButtonType.Submit,
                onClick = {

                }
            ) {
                Text("ارسال")

                showToast("emailSubmitSuccess") // todo check first if it success
            }
        }
    }
}